import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://api.olbos.ai';
const SUPABASE_KEY = 'sb_publishable_MEGFzGTTPQu9E38MPcONAQ_b6uuTG27';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);